import { Component, OnInit, Optional, Inject, HostListener } from '@angular/core';
import { InternalHomeService } from '../../../internal-home.service';
import { DialogsConfirmComponent } from '../../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { EditDialogsXmlfieldsComponent } from '../dialogs-xmlfields/edit-dialogs-xmlfields/edit-dialogs-xmlfields.component';
import { DialogsPermissionsComponent } from '../../../../../../shared/components/dialogs/dialogs-permissions/dialogs-permissions.component';
import { Xmlfields } from '../../../../../../core/entities/xmlfields.model';
import { CampsService } from './camps.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { Utils } from 'src/app/core/utils/utils';

@Component({
  selector: 'app-camps',
  templateUrl: './camps.component.html',
  styleUrls: ['./camps.component.scss']
})
export class CampsComponent implements OnInit {

  /** Subscripción para el guardado de un applicationdef */
  $guardar!: Subscription;
  xmlfield: Xmlfields = new Xmlfields();
  idCamp: number = 0;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  recojodatos: number = 0;
  mensajeError: boolean = false;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public campsService: CampsService,
              @Optional() private dialogRef: MatDialogRef<CampsComponent>,
              private translateService: TranslateService,
              private internalHomeService: InternalHomeService,
              private dialog: MatDialog) { this.campsService.build(); }

  /*@HostListener('window:keyup.g', ['$event'])
  @HostListener('window:keyup.f', ['$event'])
  onDialogClick(event: KeyboardEvent): void {
    switch(event.key){
      case 'g' : {
        this.createXmlfield();
        break;
      }
      case 'f': {
        this.dialogRef.close();
      }
    }
  }*/

  ngOnInit() {
    this.mensajeError = false;
    this.campsService.init(this.data).subscribe(result => {
      console.log(this.data);
      this.idCamp = this.data.xmldef.id;
      this.loading = false;
      this.recojodatos = this.data.xmldef.id;
    }, error => {
      this.mensajeError = true;
      this.loading = false;
      console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un xmlfield
  * @param xmldef Opcional. Xmlfield vacio.
  */
  public createXmlfield(xmlfield?: Xmlfields) {
    Utils.toggleAllButtonsAndHref(true);
    let idCodeCamp = this.idCamp;
    let titulochange = false;
    let dataId = this.recojodatos
    xmlfield = this.xmlfield;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsXmlfieldsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { xmlfield, titulochange, dataId, idCodeCamp }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      console.log(result);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un xmlfield
  * @param parametro Opcional. Xmlfield a editar.
  */
  public editXmlfield(xmlfield?: Xmlfields) {
    Utils.toggleAllButtonsAndHref(true);
    let idCodeCamp = this.idCamp;
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsXmlfieldsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { xmlfield, titulochange, idCodeCamp }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      console.log(result);
    });
  }

  /**
  * @description
  * Elimina un xmlfield
  * @param xmlfield Xmlfield a eliminar
  */
  public removeXmlfield(xmlfield?: Xmlfields) {
    Utils.toggleAllButtonsAndHref(true);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_xmlfields') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(false);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeXmlfields(xmlfield).subscribe(res => {
          console.log(res);
          //this.getAllXmldefs();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un permiso de un xmlfield
  * @param parametro Permiso de Xmlfield a editar.
  */
  public viewPermissions(xmlfield?: Xmlfields){
    if (!xmlfield) return;
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let clasepermisos = this.translateService.instant('TABLAS.xmlfield');
    let objectpermisos = xmlfield.code;
    let idpermisos = xmlfield.id;
    console.log(xmlfield);
    const dialogRef = this.dialog.open(DialogsPermissionsComponent, {
      width: '85%',
      disableClose: true,
      hasBackdrop: true,
      data: { xmlfield, titulochange, clasepermisos, objectpermisos, idpermisos }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: Xmlfields) => {
      Utils.toggleAllButtonsAndHref(false);
      console.log(result);
    });
  }

  /**
  * @description
  * Cierra el dialog applicationdefs
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
  }

}
